/**
 * Size (in px) for the profile-share QR code, clamped to fit the modal on
 * narrow phones while capping at the design size on wide screens.
 *
 * The modal reserves ~96px horizontally (outer padding 16*2 + body px-4 16*2 +
 * breathing room), so the QR must fit `windowWidth - 96`. It caps at 300 (the
 * original design size) and floors at 180 to stay scannable.
 */
export const computeQrSize = (windowWidth: number) =>
  Math.min(300, Math.max(180, windowWidth - 96));
